import { SVGNAME_TO_DIMENSIONS_MAP_CUSTOMIZABLE } from '@wre/infinity-svgs/_generatedSvgDimensCustomizable';
import { type SvgName, isSvgNameCustomizable } from '@wre/infinity-svgs';
import getSvgDimensFixed from './getSvgDimensFixed';

/**
 * Get the dimensions of an asset SVG.
 *
 * Since this is a local asset, the dimensions are statically available. If you wanted the dimensions of an image uri,
 * use react-native's `Image.getSize` or equivalent.
 */
export default function getSvgDimens(name: SvgName): {
  width: number;
  height: number;
} {
  return isSvgNameCustomizable(name)
    ? SVGNAME_TO_DIMENSIONS_MAP_CUSTOMIZABLE[name]
    : getSvgDimensFixed(name);
}
